import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Box, colors, Typography} from "@material-ui/core";
import {FormattedMessage} from "react-intl";

interface ErrorWrapperProps {
  text: string;
  title: string;
  onClose: () => void
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "14px 20px",
    border: `1px solid ${colors.red[100]}`,
    backgroundColor: "#FDECEC",
    borderRadius: "6px",
  },
  title: {
    fontSize: "0.88rem",
    color: colors.red[800],
    fontWeight: theme.typography.fontWeightBold,
  },
  textContent: {
    fontSize: "0.8rem",
    color: colors.red[800],
    fontWeight: theme.typography.fontWeightRegular,
  },
  closeAction: {
    color: colors.grey[600],
    fontSize: "0.8rem",
    cursor: "pointer",
  }
}));

export const ErrorWrapper = (props: ErrorWrapperProps) => {
  const classes = useStyles(props);

  return (
      <Box className={classes.wrapper}>
        <Box display="flex" alignItems="center">
          <Box className={classes.title} style={{flexGrow: 1}}>
            {props.title}
          </Box>
          <Box onClick={(_) => props.onClose()}>
            <Typography component="p" className={classes.closeAction}>
              <FormattedMessage id="sharedScreen.close" />
            </Typography>
          </Box>
        </Box>
        <Box mt={1}>
          <Typography component="p" className={classes.textContent} >
            {props.text}
          </Typography>
        </Box>
      </Box>
  );
};
